import { ODATA_BASE, MEDIA_BASE } from "helpers/api_config";

// Yorum sahibinin sifresi/mail adresi tarayiciya inmesin diye daraltilmis select
const USER_SELECT =
  "$select=ID,Users_Name_Surname,Users_Nickname,Users_Profile_Photo";

const stripHtml = (html) =>
  String(html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();

// Forum aciklamalari base64 saklaniyor
const decodeMaybeBase64Html = (value) => {
  if (!value) return "";
  try {
    return decodeURIComponent(escape(window.atob(value)));
  } catch (e) {
    return String(value);
  }
};

const decodeMaybeBase64 = (value) => stripHtml(decodeMaybeBase64Html(value));

// Duz metin alanlar (yorumlar) onizlemede satir sonlari korunsun diye
// basit sekilde HTML'e cevriliyor; icerik zaten HTML ise oldugu gibi kalir.
const asHtml = (value) => {
  const text = String(value || "");
  if (!text) return "";
  return /<[a-z][\s\S]*>/i.test(text) ? text : text.replace(/\n/g, "<br />");
};


/**
 * Yuklenen dosya adini tam adrese cevirir.
 * Bazi eski kayitlarda tam adres yazili; onlara dokunulmaz.
 */
const gorselAdresi = (dosya) => {
  const ad = String(dosya || "").trim();
  if (!ad) return null;
  if (/^https?:\/\//i.test(ad)) return ad;
  return `${MEDIA_BASE}/${ad.replace(/^\/+/, "")}`;
};


/**
 * Ham kolon adlarini insanin okuyabilecegi etiketlere cevirir.
 *
 * "Tum alanlari goster" tablosunda `Job_Advertisement_Address` gibi ham
 * veritabani adlari yaziyordu; moderator bunlarin ne oldugunu bilemiyordu.
 * Listede olmayan bir alan icin ad, alt tireler bosluga cevrilerek
 * yine de okunur hale getiriliyor.
 */
const ALAN_ETIKETLERI = {
  ID: "Kayıt no",
  Users_ID: "Kullanıcı no",
  // --- Ilan ---
  Job_Advertisement_Title: "İlan başlığı",
  Job_Advertisement_Desc: "İlan açıklaması",
  Job_Advertisement_Address: "Adres",
  Job_Advertisement_Number: "Telefon",
  Job_Advertisement_DateTime: "Eklenme tarihi",
  Job_Advertisement_Active: "Yayında mı?",
  Job_Advertisement_Price: "Fiyat",
  Job_Advertisement_SubCategory_ID: "Alt kategori no",
  Job_Advertisement_Views: "Görüntülenme",
  // --- Firma ---
  Company_Name: "Firma adı",
  Company_Description: "Firma açıklaması",
  Company_Adress: "Adres",
  Company_TelephoneNumber: "Telefon",
  Company_TelephoneNumber2: "2. telefon",
  Company_MailAdress: "E-posta",
  Company_Web: "Web adresi",
  Company_Add_DateTime: "Eklenme tarihi",
  Company_Active: "Yayında mı?",
  Company_Image: "Görsel",
  Company_SubCategory_ID: "Alt kategori no",
  Company_Premium: "Öne çıkan mı?",
  // --- Forum / Bir Bilen ---
  Forum_Title: "Konu başlığı",
  Forum_Short_Desc: "Kısa açıklama",
  Forum_Desc_Html: "Konu içeriği",
  Forum_DateTime: "Açılma tarihi",
  Forum_Confirmed: "Onaylı mı?",
  Forum_Views: "Görüntülenme",
  Forum_Image: "Görsel",
  Forum_Fixed: "Sabitlenmiş mi?",
  // --- Yorumlar ---
  IsActive: "Onaylı mı?",
  Forum_Comment_Text: "Yorum",
  Forum_Comment_Created_DateTime: "Yorum tarihi",
  News_Comment_Text: "Yorum",
  News_Comment_Created_DateTime: "Yorum tarihi",
  News_Comment_NickName: "Takma ad",
  News_ID: "Haber no",
  Company_Comment_Text: "Yorum",
  Company_Comment_DateTime: "Yorum tarihi",
  Company_Comment_Rating: "Puan (5 üzerinden)",
  Company_ID: "Firma no",
  ArticleDay_Comment_Text: "Yorum",
  ArticleDay_Comment_CreatedDateTime: "Yorum tarihi",
  ArticleDay_Comment_NickName: "Takma ad",
  ArticleDay_ID: "Yazı no",
  Forum_ID: "Konu no",
};

export const alanEtiketi = (alan) =>
  ALAN_ETIKETLERI[alan] || String(alan).replace(/_/g, " ");

/** true/false degerleri "Evet/Hayır", tarihleri okunur bicime cevirir. */
export const alanDegeri = (alan, deger) => {
  if (typeof deger === "boolean") return deger ? "Evet" : "Hayır";
  const metin = String(deger);
  if (/^\d{4}-\d{2}-\d{2}T/.test(metin)) {
    const t = new Date(metin);
    if (!isNaN(t)) return t.toLocaleString("tr-TR");
  }
  return metin;
};

const get = (url) =>
  fetch(url, { headers: { Accept: "application/json" } }).then((r) => {
    if (!r.ok) throw new Error("HTTP " + r.status);
    return r.json();
  });

const patch = (entity, id, body) =>
  fetch(`${ODATA_BASE}/${entity}(${id})`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body),
  }).then((r) => {
    if (!r.ok) throw new Error("HTTP " + r.status);
    return r;
  });

const remove = (entity, id) =>
  fetch(`${ODATA_BASE}/${entity}(${id})`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
  }).then((r) => {
    if (!r.ok) throw new Error("HTTP " + r.status);
    return r;
  });

/**
 * Onay bekleyen kayitlarin varlik + filtre ikilileri.
 *
 * Hem asagidaki liste sorgulari hem de menudeki "Onay Bekleyenler" rozeti
 * (components/VerticalLayout/SidebarContent.js) bu tek listeden uretiliyor;
 * yeni bir onay kuyrugu eklenince iki yeri ayri ayri guncellemek gerekmiyor.
 */
export const ONAY_SORGULARI = [
  ["Job_Advertisement", "(Job_Advertisement_Active eq false or Job_Advertisement_Active eq null)"],
  ["Company", "(Company_Active eq false or Company_Active eq null)"],
  ["Forum", "(Forum_Confirmed eq false or Forum_Confirmed eq null)"],
  ["Forum_Comment", "(IsActive eq false or IsActive eq null)"],
  ["News_Comment", "(IsActive eq false or IsActive eq null)"],
  ["Company_Comment", "(IsActive eq false or IsActive eq null)"],
  ["ArticleDay_Comment", "(IsActive eq false or IsActive eq null)"],
];

const filtre = (varlik) => {
  const kayit = ONAY_SORGULARI.find(([ad]) => ad === varlik);
  return kayit ? kayit[1] : "";
};

/**
 * Onay bekleyen toplam kayit sayisi. Her varlik icin yalniz sayim isteniyor
 * ($count=true & $top=0), satirlar indirilmiyor; erisilemeyen uc 0 sayilir.
 */
export const onayBekleyenSayisiniGetir = () =>
  Promise.all(
    ONAY_SORGULARI.map(([varlik, kosul]) =>
      get(`${ODATA_BASE}/${varlik}?$filter=${kosul}&$count=true&$top=0`)
        .then((d) => (d && d["@odata.count"]) || 0)
        .catch(() => 0)
    )
  ).then((sayilar) => sayilar.reduce((toplam, n) => toplam + n, 0));

/**
 * Onay bekleyen icerik turleri.
 *
 * Onay bayragi kolonlarinin DB varsayilani yok; eski kayitlarda NULL kalabiliyor.
 * Bu yuzden filtreler "false veya null" seklinde, hicbir kayit gozden kacmasin.
 */
// Menu rozeti ile bu listenin birbirinden ayri dusmemesi icin her turun
// varligi ve onay filtresi burada tek yerde duruyor; hem liste sorgusu hem
// de sayim ayni ikiliden uretiliyor.
export const MODERATION_TYPES = [
  {
    key: "jobAdvert",
    label: "İş İlanları",
    singular: "İlan",
    icon: "bx bx-briefcase",
    color: "warning",
    list: () =>
      get(
        `${ODATA_BASE}/Job_Advertisement?$filter=${filtre("Job_Advertisement")}&$expand=Users(${USER_SELECT}),Job_Advertisement_Image&$orderby=ID desc`
      ),
    approve: (id) =>
      patch("Job_Advertisement", id, { Job_Advertisement_Active: true }),
    remove: (id) => remove("Job_Advertisement", id),
    title: (x) => stripHtml(x.Job_Advertisement_Title) || "Başlıksız ilan",
    titleHtml: (x) => x.Job_Advertisement_Title,
    body: (x) => stripHtml(x.Job_Advertisement_Desc),
    bodyHtml: (x) => x.Job_Advertisement_Desc,
    date: (x) => x.Job_Advertisement_DateTime,
    extra: (x) => x.Job_Advertisement_Address || x.Job_Advertisement_Number || "",
    // Ilan gorselleri AYRI tabloda (Job_Advertisement_Image) tutuluyor;
    // yukaridaki $expand ile geliyor.
    images: (x) =>
      (x.Job_Advertisement_Image || [])
        .map((g) => gorselAdresi(g.Job_Advertisement_Image_Text))
        .filter(Boolean),
  },
  {
    key: "company",
    label: "Firmalar",
    singular: "Firma",
    icon: "bx bx-buildings",
    color: "info",
    list: () =>
      get(
        `${ODATA_BASE}/Company?$filter=${filtre("Company")}&$expand=Users(${USER_SELECT})&$orderby=ID desc`
      ),
    approve: (id) => patch("Company", id, { Company_Active: true }),
    remove: (id) => remove("Company", id),
    title: (x) => stripHtml(x.Company_Name) || "İsimsiz firma",
    titleHtml: (x) => x.Company_Name,
    body: (x) => stripHtml(x.Company_Description) || x.Company_Adress || "",
    bodyHtml: (x) => x.Company_Description || asHtml(x.Company_Adress),
    date: (x) => x.Company_Add_DateTime,
    extra: (x) => x.Company_TelephoneNumber || x.Company_MailAdress || "",
    images: (x) => [gorselAdresi(x.Company_Image)].filter(Boolean),
  },
  {
    key: "forum",
    label: "Forum Konuları",
    singular: "Konu",
    icon: "bx bx-conversation",
    color: "primary",
    list: () =>
      get(
        `${ODATA_BASE}/Forum?$filter=${filtre("Forum")}&$expand=Users(${USER_SELECT})&$orderby=ID desc`
      ),
    approve: (id) => patch("Forum", id, { Forum_Confirmed: true }),
    remove: (id) => remove("Forum", id),
    title: (x) => stripHtml(x.Forum_Title) || "Başlıksız konu",
    titleHtml: (x) => x.Forum_Title,
    body: (x) => decodeMaybeBase64(x.Forum_Short_Desc || x.Forum_Desc_Html),
    bodyHtml: (x) => decodeMaybeBase64Html(x.Forum_Desc_Html || x.Forum_Short_Desc),
    date: (x) => x.Forum_DateTime,
    extra: () => "",
    images: (x) => [gorselAdresi(x.Forum_Image)].filter(Boolean),
  },
  {
    key: "forumComment",
    label: "Forum Yorumları",
    singular: "Yorum",
    icon: "bx bx-comment",
    color: "secondary",
    list: () =>
      get(
        `${ODATA_BASE}/Forum_Comment?$filter=${filtre("Forum_Comment")}&$expand=Users(${USER_SELECT}),Forum&$orderby=ID desc`
      ),
    approve: (id) => patch("Forum_Comment", id, { IsActive: true }),
    remove: (id) => remove("Forum_Comment", id),
    title: (x) => stripHtml(x.Forum && x.Forum.Forum_Title) || "Forum",
    titleHtml: (x) => (x.Forum && x.Forum.Forum_Title) || "Forum",
    body: (x) => stripHtml(x.Forum_Comment_Text),
    bodyHtml: (x) => asHtml(x.Forum_Comment_Text),
    date: (x) => x.Forum_Comment_Created_DateTime,
    extra: () => "",
    // Yorumun YAZILDIGI icerik: moderator neye yorum yapildigini
    // govdesi ve gorseliyle birlikte gormeli.
    hedef: (x) => x.Forum && {
      tur: 'Konu',
      baslik: x.Forum.Forum_Title,
      govde: decodeMaybeBase64Html(x.Forum.Forum_Desc_Html || x.Forum.Forum_Short_Desc),
      gorseller: [gorselAdresi(x.Forum.Forum_Image)].filter(Boolean),
    },
  },
  {
    key: "newsComment",
    label: "Aktüel Yorumları",
    singular: "Yorum",
    icon: "bx bx-news",
    color: "danger",
    list: () =>
      get(
        `${ODATA_BASE}/News_Comment?$filter=${filtre("News_Comment")}&$expand=Users(${USER_SELECT}),News&$orderby=ID desc`
      ),
    approve: (id) => patch("News_Comment", id, { IsActive: true }),
    remove: (id) => remove("News_Comment", id),
    title: (x) => stripHtml(x.News && x.News.News_Title) || "Aktüel",
    titleHtml: (x) => (x.News && x.News.News_Title) || "Aktüel",
    body: (x) => stripHtml(x.News_Comment_Text),
    bodyHtml: (x) => asHtml(x.News_Comment_Text),
    date: (x) => x.News_Comment_Created_DateTime,
    extra: () => "",
    hedef: (x) => x.News && {
      tur: 'Aktüel haber',
      baslik: x.News.News_Title,
      govde: decodeMaybeBase64Html(x.News.News_Desc),
      gorseller: [gorselAdresi(x.News.News_Image)].filter(Boolean),
    },
  },
  {
    // Firma yorum + puanlama (2026-09-01'de eklendi).
    // Company_Comment ucu 2026-09-02 itibariyla OData'da yayinda ve
    // IsActive filtresi calisiyor; asagidaki hata toleransi yalnizca
    // gecici servis hatalarinda sayfanin komple bosalmamasi icin duruyor.
    key: "companyComment",
    label: "Firma Yorumları",
    singular: "Yorum",
    icon: "bx bx-star",
    color: "success",
    list: () =>
      get(
        `${ODATA_BASE}/Company_Comment?$filter=${filtre("Company_Comment")}&$expand=Users(${USER_SELECT}),Company&$orderby=ID desc`
      ).catch(() => ({ value: [] })),
    approve: (id) => patch("Company_Comment", id, { IsActive: true }),
    remove: (id) => remove("Company_Comment", id),
    title: (x) => stripHtml(x.Company && x.Company.Company_Name) || "Firma",
    titleHtml: (x) => (x.Company && x.Company.Company_Name) || "Firma",
    body: (x) => stripHtml(x.Company_Comment_Text),
    bodyHtml: (x) => asHtml(x.Company_Comment_Text),
    date: (x) => x.Company_Comment_DateTime,
    extra: (x) => (x.Company_Comment_Rating ? `${x.Company_Comment_Rating}/5 puan` : ""),
    hedef: (x) => x.Company && {
      tur: 'Firma',
      baslik: x.Company.Company_Name,
      govde: x.Company.Company_Description || x.Company.Company_Adress || '',
      gorseller: [gorselAdresi(x.Company.Company_Image)].filter(Boolean),
    },
  },
  {
    // Soz Sizde / Esnaf Aktuel yorumlari (2026-09-01'de eklendi).
    //
    // Bu yorumlar DENETIMSIZ tek icerik kanaliydi: haber ve forum yorumlari
    // onaya duserken ArticleDay_Comment tablosunda IsActive kolonu olmadigi
    // icin buraya yazilan her yorum dogrudan yayina giriyordu.
    //
    // ArticleDay_Comment.IsActive kolonu eklendi ve uc 2026-09-02
    // itibariyla filtreyi kabul ediyor; asagidaki hata toleransi
    // yalnizca gecici servis hatalari icin duruyor.
    key: "articleDayComment",
    label: "Söz Sizde Yorumları",
    singular: "Yorum",
    icon: "bx bx-message-square-detail",
    color: "dark",
    list: () =>
      get(
        `${ODATA_BASE}/ArticleDay_Comment?$filter=${filtre("ArticleDay_Comment")}&$expand=Users(${USER_SELECT}),ArticleDay&$orderby=ID desc`
      ).catch(() => ({ value: [] })),
    approve: (id) => patch("ArticleDay_Comment", id, { IsActive: true }),
    remove: (id) => remove("ArticleDay_Comment", id),
    title: (x) =>
      stripHtml(x.ArticleDay && x.ArticleDay.ArticleDay_Title) || "Söz Sizde",
    titleHtml: (x) => (x.ArticleDay && x.ArticleDay.ArticleDay_Title) || "Söz Sizde",
    body: (x) => stripHtml(x.ArticleDay_Comment_Text),
    bodyHtml: (x) => asHtml(x.ArticleDay_Comment_Text),
    date: (x) => x.ArticleDay_Comment_CreatedDateTime,
    extra: (x) => x.ArticleDay_Comment_NickName || "",
    hedef: (x) => x.ArticleDay && {
      tur: 'Söz Sizde yazısı',
      baslik: x.ArticleDay.ArticleDay_Title,
      govde: decodeMaybeBase64Html(x.ArticleDay.ArticleDay_LongDesc),
      gorseller: [gorselAdresi(x.ArticleDay.ArticleDay_Image)].filter(Boolean),
    },
  },
];
